<script>
export default {
  name: 'AdminFilterBar',
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    inline: {
      type: Boolean,
      default: true,
    },
    showReset: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateFieldValue(key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value })
    },
    onSearch() {
      this.$emit('search')
    },
    onReset() {
      this.$emit('reset')
    },
  },
}
</script>

<template>
  <div class="admin-filter-bar admin-page-card" :class="{ 'is-stacked': !inline }">
    <div class="admin-filter-bar__fields">
      <template v-for="field in fields" :key="field.key">
        <slot
          v-if="field.type === 'custom'"
          :name="`field-${field.key}`"
          :field="field"
          :model-value="modelValue[field.key]"
          :set-value="(v) => updateFieldValue(field.key, v)"
        />

        <v-text-field
          v-else-if="field.type === 'text'"
          :label="field.label"
          :placeholder="field.placeholder || ''"
          density="comfortable"
          variant="outlined"
          hide-details
          :model-value="modelValue[field.key] ?? ''"
          @update:model-value="(v) => updateFieldValue(field.key, v)"
        />

        <v-select
          v-else-if="field.type === 'select'"
          :label="field.label"
          :items="field.options || []"
          :item-title="field.itemTitle || 'title'"
          :item-value="field.itemValue || 'value'"
          density="comfortable"
          variant="outlined"
          hide-details
          :model-value="modelValue[field.key] ?? null"
          @update:model-value="(v) => updateFieldValue(field.key, v)"
        />
      </template>
    </div>

    <div class="admin-filter-bar__actions">
      <v-btn v-if="showReset" variant="tonal" color="secondary" @click="onReset">초기화</v-btn>
      <v-btn v-if="showSearch" variant="flat" color="primary" @click="onSearch">검색</v-btn>
    </div>
  </div>
</template>

<style scoped>
.admin-filter-bar {
  padding: var(--admin-space-4);
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: var(--admin-space-3);
}

.admin-filter-bar.is-stacked {
  flex-direction: column;
  align-items: stretch;
}

.admin-filter-bar__fields {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--admin-space-3);
}

.admin-filter-bar__actions {
  display: flex;
  align-items: center;
  gap: var(--admin-space-2);
}
</style>
